/**
 * 型式から車名一覧取得APIからのレスポンス（JSON）ステータスチェック
 * @param {any} res - 型式から車名一覧取得APIからのレスポンス
 */
export function isErrorInCarListFromModel(res: any) {
  return res.data.status.code !== "0000"
}
/**
 * 簡易試算APIからのレスポンス（JSON）ステータスチェック
 * @param {any} res - 簡易試算APIからのレスポンス
 */
export function isErrorInEasyCalculation(res: any) {
  return res.data.EASIMessage.EASIBody.ResultBlc.StatusCode !== "0000"
}
/**
 *  見積保存APIからのレスポンス（JSON）ステータスチェック
 * @param {any} res - 見積保存APIからのレスポンス
 */
export function isErrorInSave(res: any) {
  return res.data.EASIMessage.EASIBody.ResultBlc.StatusCode !== "0000"
}
